import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ChatMessage {
  from: string;
  text: string;
  timestamp: number;
  sender: {
    name: string;
    id: string;
    email: string;
  };
}

export interface ChatState {
  messagesByMeeting: Record<string, ChatMessage[]>;
}

export const initialState: ChatState = {
  messagesByMeeting: {},
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addMessage: (
      state,
      action: PayloadAction<{
        meetingId: string;
        message: ChatMessage;
      }>
    ) => {
      const { meetingId, message } = action.payload;
      if (!state.messagesByMeeting) {
        state.messagesByMeeting = {};
      }
      if (!state.messagesByMeeting?.[meetingId.toString()]) {
        state.messagesByMeeting[meetingId] = [];
      }

      state.messagesByMeeting[meetingId.toString()].push(message);
    },
    removeAllMessagesByMeetingId: (
      state,
      action: PayloadAction<{ meetingId: string }>
    ) => {
      const { meetingId } = action.payload;

      if (state.messagesByMeeting[meetingId]) {
        state.messagesByMeeting[meetingId] = [];
      }
    },
    removeAllMessages: (state) => {
      state.messagesByMeeting = {};
      console.log("All messages removed");
    },
  },
});

export const { addMessage, removeAllMessagesByMeetingId, removeAllMessages } =
  chatSlice.actions;
export default chatSlice.reducer;
